module.exports = {
  API_ENDPOINT: `https://infinite-cliffs-30759.herokuapp.com/api`,
};